<form [formGroup]="vinForm">
  <h4 class="font-weight-semibold font-size-1-50">{{ vinChangeConfig.header }}</h4>

  @if (!isPartner) {
    <div class="pad-vertical-10 flex flex-direction-column">
      <div class="font-9 pad-bottom-10 font-weight-semibold">{{ vinChangeConfig.question }}</div>
      <div class="radio-group">
        <ds-radio-group
          class="options"
          control="flow"
          [alignInline]="true"
          [parentFormGroup]="vinForm"
          [options]="flowOptions"
          [selectedAnswer]="flowOptions[0].id"
        >
        </ds-radio-group>
      </div>
    </div>
  }

  <div class="pad-vertical-10 flex flex-direction-column">
    <ds-form-control-container
      [labelText]="vinChangeConfig.vehicleHeader"
      [control]="vehiclesControl"
      [boldLabel]="true"
    >
      <select id="vehicles" class="icon" formControlName="vehicle" data-cy="addVehicleYearSelect">
        <option value="unset" selected disabled>Select vehicle</option>
        @for (vehicle of vehicles; track vehicle.vehicleId) {
          <option [value]="vehicle.vehicleId">
            {{ vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model }}
          </option>
        }
      </select>
      <span class="icon-chevron-down"></span>
      <ds-form-control-message [control]="vehiclesControl"></ds-form-control-message>
    </ds-form-control-container>

    @if (currentVin) {
      <div class="hint pad-top-4 font-weight-semibold">Current VIN: {{ currentVin }}</div>
    }
  </div>

  @if (!isReplaceVehicleFlow) {
    <div class="pad-vertical-10 flex flex-direction-column">
      <ds-form-control-container
        [labelText]="vinChangeConfig.yearHeader"
        [control]="yearControl"
        [boldLabel]="true"
      >
        <select id="year" class="icon" formControlName="year" data-cy="addVehicleYearSelect">
          <option value="unset" selected disabled>{{ vinChangeConfig.yearPlaceholder }}</option>
          @for (year of years; track year) {
            <option [value]="year">{{ year }}</option>
          }
        </select>
        <span class="icon-chevron-down"></span>
        <ds-form-control-message [control]="yearControl"></ds-form-control-message>
      </ds-form-control-container>
    </div>
    <div class="pad-vertical-10 flex flex-direction-column">
      <ds-form-control-container
        [labelText]="vinChangeConfig.newVinHeader"
        [boldLabel]="true"
        [control]="vinControl"
      >
        <input type="text" id="vin" class="fill" formControlName="newVin" data-cy="licenseNumber" />
        <ds-form-control-message [control]="vinControl"></ds-form-control-message>
      </ds-form-control-container>
      @if (vehicleInfo) {
        <div class="hint pad-top-4 font-weight-semibold">
          {{ vehicleInfo.year }} {{ vehicleInfo.make }} {{ vehicleInfo.model }}
          {{ vehicleInfo.series || '' }}
        </div>
      }
    </div>
  }

  @if (msrp$ | async) {
    <div class="pad-vertical-10 flex flex-direction-column">
      <ds-form-control-container
        [labelText]="'Select a Vehicle Make'"
        [control]="makeControl"
        [width]="200"
      >
        <select
          id="make"
          class="icon"
          formControlName="make"
          data-cy="replaceVehicleMakeSelect"
          (change)="loadModels()"
        >
          <option value="unset" selected disabled>Select a Vehicle Make</option>
          @let makes = vehicleFacade.makes$ | async;
          @for (make of makes; track make) {
            <option [value]="make">{{ make }}</option>
          }
          <option value="other">Other</option>
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
    </div>

    <div class="pad-vertical-10 flex flex-direction-column">
      <ds-form-control-container [labelText]="'Select a Vehicle Model'" [control]="modelControl">
        <select
          id="model"
          class="icon"
          formControlName="model"
          data-cy="replaceVehicleModelSelect"
          (change)="loadSeries()"
        >
          <option value="unset" selected disabled>Select a Vehicle Model</option>
          @let models = vehicleFacade.models$ | async;
          @for (model of models; track model) {
            <option [value]="model">{{ model }}</option>
          }
          <option value="other">Other</option>
        </select>
        <span class="icon-chevron-down"></span>
      </ds-form-control-container>
    </div>

    @let series = vehicleFacade.series$ | async;
    @if (series?.length) {
      @if (series?.length) {
        <div class="pad-vertical-10 flex flex-direction-column">
          <ds-form-control-container
            [labelText]="'Select a Vehicle Series'"
            [control]="seriesControl"
          >
            <select
              id="series"
              class="icon"
              formControlName="series"
              data-cy="replaceVehicleSeriesSelect"
            >
              <option value="unset" selected disabled>Select a Vehicle Series</option>
              @for (vehicleSeries of series; track vehicleSeries) {
                <option [value]="vehicleSeries">
                  {{ vehicleSeries }}
                </option>
              }
              <option value="other">Other</option>
            </select>
            <span class="icon-chevron-down"></span>
          </ds-form-control-container>
        </div>
      }
    }
  }

  <div class="pad-vertical-10 flex flex-direction-column">
    <ds-form-control-container
      [labelText]="vinChangeConfig.reasonHeader"
      [control]="reason"
      [boldLabel]="true"
    >
      <textarea
        maxlength="850"
        id="reasonText"
        class="fill"
        formControlName="reason"
        rows="10"
        data-cy="requestChangeReasonInput"
        textCounter
        [maxCount]="850"
      ></textarea>
      <ds-form-control-message [control]="reason"></ds-form-control-message>
    </ds-form-control-container>
  </div>

  <div class="pad-vertical-10 flex flex-direction-column">
    <!-- Action Buttons -->
    <call-to-action
      [primaryButtonName]="primaryButtonName"
      [tertiaryButtonName]="vinChangeConfig.cancel"
      [capitalize]="true"
      [disablePrimaryButton]="!valid"
      (primaryEvent)="onSubmit()"
      (tertiaryEvent)="cancel()"
    >
    </call-to-action>
  </div>
</form>
<ds-modal
  [id]="agentsModal"
  [closeOthers]="true"
  [showCloseButton]="false"
  [closeOnBackdropClick]="false"
>
  <div class="margin-bottom-20">
    <app-agent-selector
      [agents]="agents"
      primaryButtonName="Submit"
      secondaryButtonName="Cancel"
      (sendToAgent)="sendToAgent($event)"
      (cancel)="closeModal()"
    ></app-agent-selector>
  </div>
</ds-modal>
